import { render, staticRenderFns } from "./menu1_images_scence_q.vue?vue&type=template&id=86e4bbdc&scoped=true"
import script from "./menu1_images_scence_q.vue?vue&type=script&lang=js"
export * from "./menu1_images_scence_q.vue?vue&type=script&lang=js"
import style0 from "./menu1_images_scence_q.vue?vue&type=style&index=0&id=86e4bbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e4bbdc",
  null
  
)

export default component.exports